import { render, staticRenderFns } from "./EndpointSecurity.vue?vue&type=template&id=7a71c292&scoped=true&"
import script from "./EndpointSecurity.vue?vue&type=script&lang=js&"
export * from "./EndpointSecurity.vue?vue&type=script&lang=js&"
import style0 from "./EndpointSecurity.vue?vue&type=style&index=0&id=7a71c292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a71c292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a71c292')) {
      api.createRecord('7a71c292', component.options)
    } else {
      api.reload('7a71c292', component.options)
    }
    module.hot.accept("./EndpointSecurity.vue?vue&type=template&id=7a71c292&scoped=true&", function () {
      api.rerender('7a71c292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serviceDetails/EndpointSecurity.vue"
export default component.exports